<template>
	<div class="searchheader">
		<form action="/">
			<Search v-model="keyname" :placeholder="placeholder" :show-action="isshow" @focus="show" @search="onSearch" @cancel="onCancel" />
		</form>
		<div class=" page-container-margin searchbody">
			<div  v-if="matchList.length>0">
				<div class="subheader">
					搜索结果
				</div>
				<div class="matchlist">
					<MatchList :list="matchList" ></MatchList>
				</div>
			</div>
			<div v-else>
				<div class="historysearch">
					<div class="subheader">
						历史搜索
					</div>
					<div v-if="searchHistory.length>0" class="searchresult">
						<div v-for="item in searchHistory" :key="item.id" @click="searchbyHistory(item)">
							{{item}}
						</div>
					</div>
					<!--<div wx:else>-->
					<!--<div> 暂无历史搜索</div>-->
					<!--</div>-->
					<div v-else class="line">
						<Divider>暂无历史搜索</Divider>
					</div>
				</div>
				<div class="hotmatch">
					<div class="subheader">
						推荐
					</div>
					<div class="matchlist">
						<MatchList v-if="hotmatchList.length>0" :list="hotmatchList" @infiniteHandler="infiniteHandler"></MatchList>
						<infinite-loading v-if="hotmatchList.length>0" @infinite="infiniteHandler"></infinite-loading>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import './search.less'
    import MatchList from '@/components/matchList'
    import {recommend,search} from '@/libs/api'
    import {Search,Divider} from 'vant'
    import {setStorage, getStorage,formatTime} from '@/libs/utils'
    export default {
        name: 'index',
        data() {
            return {
                matchList: [],
                isshow: false,
                hotmatchList: [],
                searchHistory: [],
                keyname: '',
                urid: '',
                token: '',
                placeholder: '请输入关键词搜索',
                type: '',
                matchid: '',
                searchfun: 'search'
            }
        },
        components: {
            MatchList,
            Search,
            Divider
        },
        methods: {
			infiniteHandler:function($state){
				// this.handleSpinShow(true);
				recommend({page:this.page,type: 1,urid:this.urid,token:this.token}).then((res) => {
					if (res.status== 200) {
						if(res.data.list){
							if(res.data.list.length>0){
								this.page+=1;
								this.hotmatchList.push(...res.data.list)
								$state.loaded()
							}else{
								$state.complete()
							}
						}else{
							this.hotmatchList = []
						}


					}
					// this.handleSpinShow(false);
				})
			},
			onSearch(){
				if(this.keyname != ''){
					//保存搜索历史
					var searchHistory = []
					if (this.searchHistory.length == 0) {
						searchHistory = [this.keyname]

					} else {

						if (this.searchHistory.length == 6) {
							this.searchHistory.pop();
						}

						this.searchHistory.forEach((item, index) => {

							if (item == this.keyname) {
							this.searchHistory.splice(index, 1);
							}

						})

						this.searchHistory.unshift(this.keyname);
						searchHistory = this.searchHistory;
					}
					if(this.searchfun=='searchregister'){
						setStorage("regsearchHistory",searchHistory,true)
			        }else{
			        	setStorage("searchHistory",searchHistory,true)
			        }
					this.getMatchList();
				}

			},
			getMatchList() {
				search({keyname: this.keyname,urid:this.urid,token:this.token}).then((res) => {
					if (res.status == 200) {
						if(res.data.list){
							if (res.data.list.length > 0) {
								var list = res.data.list;
								var date = new Date();
								list.forEach((item) => {
									date.setTime(item.starttime * 1000);
									item.starttime = formatTime(date);
									switch (item.state) {
										case 10:
										item.color = '#CCCCCC';
										item.statetips = '未开始';
										break;
										case 11:
										item.color = '#23BC6A';
										item.statetips = '报名中';
										break;
										case 12:
										item.color = '#F19224';
										item.statetips = '报名截止';
										break;
										case 99:
										item.color = '#BC7B23';
										item.statetips = '已结束';
										break;
									}
								})

								this.matchList = list
							} 
						}else{
							this.matchlist = []
						}	                

					} 
				})
			},
			onCancel(){
				this.isshow = false
			},
			show(){
				this.isshow =  true
			},
            searchbyHistory(e){
                this.keyname = e
                this.isshow =  true
                this.getMatchList();
            }
        },
		mounted() {
			this.$nextTick(() => {
				let userinfo = getStorage('userInfo')
				this.urid = userinfo.urid
				this.token = userinfo.token
				if(this.$route.params){
					this.matchid = this.$route.params.matchid;
					this.type = this.$route.params.type;
				}				
				if(this.type == 'searchregister'){
					this.placeholder = "请输入证件号码查询"
					this.searchfun = "searchRegister"
					if(getStorage('regsearchHistory')){
						this.searchHistory = getStorage('regsearchHistory')
					}else{
						this.searchHistory = []
					}
				}else{
					if(getStorage('searchHistory')){
						this.searchHistory = getStorage('searchHistory')
					}else{
						this.searchHistory = []
					}
				}
			})
		}
    }
</script>